import Vue from "vue";
import { IOTPOptions } from "./interfaces/IOTPOptions";
declare module "vue/types/vue" {
  interface Vue {
    getError(fieldName: any): any;
    validate(): any;
    readableDate(date: string): string;
    formatDate(date: string, format: string): string;
    handleError(error: any): any;
    toastSuccess(message: string): any;
    toastError(message: string): any;
    isLoading: boolean;
    errors?: any;
    loadJs(): any;
    loadDependencyJS(srcs: string[]): void;
    globalLoader(status: boolean, message?: string): any;
    showLoading(message?: string): void;
    requestWrapper<T>(promise: Promise<T>): Promise<T>;
    hideLoading(): void;
    modal(modalId: string, show: boolean): any;
    confirm(payload: any, func: any, success?: string): any;
    makeOTPScreenPayload(payload: IOTPOptions): string;
    getOTPScreenPayload(hash: string): IOTPOptions;
    moneyFormat(value: number): string;
    // errors: any;
  }
}

declare global {
  interface Window {
    jQuery: any;
    jKanban: any;
    Quill: any;
    am4core: any;
    am4charts: any;
    am4themes_animated: any;
    xxx: any;
    yyy: any;
  }
  interface Array<T> {
    sum(field: string): number;
  }

  let global: any;
}

Array.prototype.sum = function(field: string) {
  return this.reduce((accumulator, object) => {
    return accumulator + object[field];
  }, 0);
};
